//
import { mapActions } from "vuex"
import { ModelDataTable } from "@/components/reusable_components/next"

//
import PosWorkstationUserModel from "@/models/General/GPosWorkstationUser"

//
import filters from "./filters"
import headers from "./headers"

//
export default {
    name: "pos-workstation-user-list",
    components: {
        ModelDataTable,
    },
    computed: {

        /**
         *
         */
        tableProps () {
            return {
                service: PosWorkstationUserModel,
                filters,
                headers,
                mapper: row => row.reset()
            }
        },
    },
    data () {
        return {
            selected: null,
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
            setItemsTopBar: "setItemsTopBar",
        }),

        /**
         * 
         */
        delete () {
            this.selected.toDelete().delete().then( this.successDelete ).then( this.$refs.table.refresh ).catch( this.errorDelete ); 
        },

        /**
         *
         */
        errorDelete ( error ) {
            this.$toast.error( error.message )
        },

        /**
         *
         */
        submitCreate () {
            this.$router.push({ name: "pos-workstation-user-create" })
        },

        /**
         *
         */
        submitDelete ( event ) {
            this.selected = event.item
            this.$toast.confirm( "¿Confirma la eliminación del punto de venta seleccionado?", this.$toaster( this, this.delete ) )
        },
        
        /**
         *
         */
        submitUpdate ( event ) {
            this.$router.push({ name: "pos-workstation-user-update", params: { id: event.item.id } })
        },

        /**
         * 
         */
        successDelete () {
            this.$toast.success( "Punto de venta eliminado exitosamente." )
        },
    },
    beforeMount () {
        this.setTitleTopBar( "Puntos de venta" )
        this.setItemsTopBar([
            {
                action: this.submitCreate,
                color: "accent",
                icon: "add_circle",
                text: "crear punto de venta",
                tip: "Crear nuevo punto de venta",
            }
        ])
    },
}